import React, { Component } from 'react';

import { chainesLocales } from './../include/chainesLocales';

class ErreurSupport extends Component {
    get labels() {
        return chainesLocales['ErreurSupport'][this.props.lang];
    }

    render() {
        return (
            <div dangerouslySetInnerHTML={{ __html: this.labels.text }} />
        );
    }
}

export default ErreurSupport